import OrganizationTransferSuccessModal from './OrganizationTransferSuccessModal';

export default OrganizationTransferSuccessModal;
